import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { TabularQuestion } from 'src/app/models/TabularQuestion.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-table-part',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateDirective, TranslatePipe],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TablePartComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TablePartComponent,
            multi: true
        }
    ],
    templateUrl: './table-part.component.html',
    styleUrls: ['./table-part.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TablePartComponent implements OnInit, ControlValueAccessor, Validator {

  @Output()
  deleteEvent = new EventEmitter();
  #builder = inject(FormBuilder);
  tablePartForm = this.#builder.group({
    title: new FormControl<string>(''),
    order: new FormControl<number>(0)
  });
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.tablePartForm.valueChanges.subscribe(part => {
      this.registerOnChangeCallback({ ...part });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.tablePartForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }

  writeValue(obj: TabularQuestion): void {
    this.tablePartForm.patchValue({ ...obj }, { emitEvent: false });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  delete() {
    this.deleteEvent.emit()
  }
}
